// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => CustomerLanguage.loadInternal(), entryList => {
        CustomerLanguage.θentryList.set(entryList)
        CustomerLanguage.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class CustomerLanguage {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label", "flag"] as const,
        allPropertyNames: ["id", "label", "flag"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<CustomerLanguage.Id | null>;
    static readonly Id = String;
    static ids: CustomerLanguage.Id[] = [] as any;
    static idsAndDisplayValues: Record<CustomerLanguage.Id, string> = {} as any;
    static θentryList = signal<CustomerLanguage.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<CustomerLanguage.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? CustomerLanguage.getEntryMap()[id]?.label : undefined
    });
    readonly θflag = computed(() => {
        const id = this.θid()
        return id !== null ? CustomerLanguage.getEntryMap()[id]?.flag : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return CustomerLanguage[BoInfoSymbol]
    }

    get __type(): 'Orders.CustomerLanguage' {
        return 'Orders.CustomerLanguage'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.CustomerLanguage' {
        return 'Orders.CustomerLanguage'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): CustomerLanguage.Id | null {
        return this.θid()
    }

    set id(id: CustomerLanguage.Id | CustomerLanguage | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !CustomerLanguage.getEntry(id as CustomerLanguage.Id)) throw new Error('Invalid id for type Orders.CustomerLanguage: ' + id)
        this.θid.set(id as CustomerLanguage.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): CustomerLanguage.Id[] {
        return CustomerLanguage.ids
    }

    get idsAndDisplayValues(): Record<CustomerLanguage.Id, string> {
        return CustomerLanguage.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[CustomerLanguage.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get flag() {
        return this.θflag()
    }

    get isGerman() {
        return this.id == 'de'
    }

    static get German() {
        return new this('de')
    }

    get isEnglish() {
        return this.id == 'en'
    }

    static get English() {
        return new this('en')
    }

    get isFrench() {
        return this.id == 'fr'
    }

    static get French() {
        return new this('fr')
    }

    constructor(idOrObject: CustomerLanguage.Id | CustomerLanguage | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): CustomerLanguage.Entry[] {
        return This.CustomerLanguage.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): CustomerLanguage.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: CustomerLanguage.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof CustomerLanguage.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = CustomerLanguage.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<CustomerLanguage.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new CustomerLanguage(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: CustomerLanguage.Id | CustomerLanguage | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as CustomerLanguage.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: CustomerLanguage.Id | CustomerLanguage) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<CustomerLanguage.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.CustomerLanguage yet:', err.message)
            //throw err
        })
    }

    setGerman() {
        this.id = 'de'

    }

    setEnglish() {
        this.id = 'en'

    }

    setFrench() {
        this.id = 'fr'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "de", label: "German", flag: "🇩🇪" }),
            Object.freeze({ id: "en", label: "English", flag: "🇬🇧" }),
            Object.freeze({ id: "fr", label: "French", flag: "🇫🇷" })
        ] as CustomerLanguage.Entry[]) as CustomerLanguage.Entry[]
    }
}
jsonClass('Orders.CustomerLanguage')(CustomerLanguage)

export const CustomerLanguageθId = String;

export type CustomerLanguageθId = string;

export namespace CustomerLanguage {
    export type Id = 'de' | 'en' | 'fr'

    export interface Entry {
        id: CustomerLanguage.Id;
        label: string;
        flag: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => CustomerLanguage.load(true))
